import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortTags' })
export class SortTagsPipe implements PipeTransform {
    public transform(orginalItems: any[], phrase: string): any {

        let items = JSON.parse(JSON.stringify(orginalItems));

        if (items && phrase) {

            items = items.sort((a: any, b: any) => {
                const _phrase = phrase.toLowerCase();
                const _a = a.L.toLowerCase();
                const _b = b.L.toLowerCase();

                const _ai = _a.indexOf(_phrase);
                const _bi = _b.indexOf(_phrase);

                // w obu wystepuje
                if (_ai !== -1 && _bi !== -1) {
                    if (_ai > _bi) {
                        return 1;
                    } else if (_ai < _bi) {
                        return -1;
                    } else {
                        // w przypoadku jak jest to samo sortujemy standardowo
                        if (_a.length > _b.length) {
                            return 1;
                        } else if (_a.length < _b.length) {
                            return -1;
                        } else {
                            if (_a > _b) {
                                return 1;
                            } else if (_a < _b) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    }
                } else if (_ai !== -1 && _bi === -1) {
                    return 1;
                } else if (_bi !== -1 && _ai === -1) {
                    return 1;
                } else {

                    if (_a > _b) {
                        return 1;
                    } else if (_a < _b) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            });

        } else if (items) {
            items = items.sort((a: any, b: any) => {
                const _a = a.L.toLowerCase();
                const _b = b.L.toLowerCase();
                if (_a > _b) {
                    return 1;
                } else if (_a < _b) {
                    return -1;
                } else {
                    return 0;
                }
            });
        }

        return items;
    }
}
